<tm-menubar-button [component]="componentType"
                   [panelTitle]="panelTitle$ | async"
                   icon="components_component_buttons"></tm-menubar-button>
